import React, { Component } from "react";
import { connect } from "react-redux";
import { changeSwModeAction } from "../../redux/app/actions";
import { redYLine } from "../../redux/csDsp/reducer";
import {
  changeCsLineAction,
  changeElvDepRdoAction,
  changeYLineChkAction,
  changeBoringChkAction,
  changeWlChkAction,
  changeProbChkAction,
  changeXScaleAction,
  changeYScaleAction,
  changeYLineAction,
  changeBWidthAction,
  changeXListAction,
  changeYListAction,
  changeYLineListAction,
  changeWlLineListAction,
  changeBListAction,
  changeBList2Action,
  changeProbListAction,
  resetCellAction,
  clickCellAction,
  scrTopAction,
  scrLeftAction,
} from "../../redux/csDsp/actions";
import { openSwAction, openProbAction } from "../../redux/ui/actions";
import Lgd, { getContColor } from "../common/Lgd";
import { divNumOpt } from "../estCs/Main";

const mapStateToProps = state => {
  return {
    swMode: state.appReducer.swMode,
    boringDs: state.boringReducer.dataset,
    resultDs: state.csDspReducer.data,
    csLine: state.csDspReducer.csLine,
    elvDepRdo: state.csDspReducer.elvDepRdo,
    YLineChk: state.csDspReducer.YLineChk,
    boringChk: state.csDspReducer.boringChk,
    wlChk: state.csDspReducer.wlChk,
    probChk: state.csDspReducer.probChk,
    XScale: state.csDspReducer.XScale,
    YScale: state.csDspReducer.YScale,
    YLine: state.csDspReducer.YLine,
    bWidth: state.csDspReducer.bWidth,
    XList: state.csDspReducer.XList,
    YList: state.csDspReducer.YList,
    YLineList: state.csDspReducer.YLineList,
    wlLineList: state.csDspReducer.wlLineList,
    bList: state.csDspReducer.bList,
    bList2: state.csDspReducer.bList2,
    cellInfo: state.csDspReducer.cellInfo,
    probList: state.csDspReducer.probList,
    scrTop: state.csDspReducer.scrTop,
    scrLeft: state.csDspReducer.scrLeft,
    csLineDs: state.csLineReducer.dataset,
    geoDs: state.geoReducer.dataset,
    modelDep: state.lrnReducer.modelDep,
    editerSw: state.uiReducer.editerSw,
    probSw: state.uiReducer.probSw,
  };
};

class Main extends Component {
  constructor(props) {
    super(props);
    this.scaleWidth = 15; //1目盛 = 15px
    this.maxX = null;
    this.maxY = null;
    this.editerSw = false;
    this.XScale = null;
    this.YScale = null;
    this.YLine = this.props.YLine; //補助目盛線
    this.YLineW = 0;
    this.elevMaxY = null;
    this.elevMinY = null;
    this.bWidth = null;
    this.XList = [];
    this.YList = [];
    this.YLineList = [];
    this.wlData = []; //地下水標高の要素作成のためのデータを格納
    this.wlLineList = []; //地下水標高の要素を格納
    this.bList = [];
    this.bList2 = [];
    this.probList = [];
    this.elvDepRdo = this.props.elvDepRdo;
    this.YLineChk = this.props.YLineChk;
    this.boringChk = this.props.boringChk;
    this.wlChk = this.props.wlChk;
    this.probChk = this.props.probChk;
    this.$hoverCell = null; //マウスオーバーセルエレメント
    this.$cell = null; //クリックセルエレメント

    this.changeCsLine = this.changeCsLine.bind(this);
    this.changeElvDepRdo = this.changeElvDepRdo.bind(this);
    this.changeYLineChk = this.changeYLineChk.bind(this);
    this.changeBoringChk = this.changeBoringChk.bind(this);
    this.changeWlChk = this.changeWlChk.bind(this);
    this.changeProbChk = this.changeProbChk.bind(this);
    this.openProbSw = this.openProbSw.bind(this);
    this.changeXScale = this.changeXScale.bind(this);
    this.changeYScale = this.changeYScale.bind(this);
    this.changeYLine = this.changeYLine.bind(this);
    this.changeBWidth = this.changeBWidth.bind(this);
    this.clickCell = this.clickCell.bind(this);
    this.createDiag = this.createDiag.bind(this);
    this.doScroll = this.doScroll.bind(this);
    this.hglBoring = this.hglBoring.bind(this);
    this.hglCsLineSec = this.hglCsLineSec.bind(this);
    this.getDecPath = this.getDecPath.bind(this);

    this.scaleXRef = React.createRef();
    this.scaleYRef = React.createRef();

    //結果データが存在する場合
    if (0 < this.props.resultDs.length) {
      this.createDiag(this.props.csLine, true);
      window.hglCsLine(this.props.csLine + 1);
      window.changeRsltCsSw(true);
    }
  }

  componentDidUpdate(prevProps) {
    /*
     * ボーリングエディタ表示の場合、
     * ボーリングレイヤーホバーを無効にする
     * @since hara 2020-09-09
     */
    if (prevProps.editerSw !== this.props.editerSw) {
      this.editerSw = this.props.editerSw;
      this.createDiag(this.props.csLine);
    }

    //別ウィンドウを開いている場合
    if (this.props.probSw) {
      /*
       * 別ウィンドウのスクロール（上下）連動
       * @since hara 2021-02-09
       */
      if (prevProps.scrTop !== this.props.scrTop) {
        const YList = document.getElementById("sepSw_YList");
        const main = document.getElementById("sepSw_main");
        YList.scrollTop = this.props.scrTop;
        main.scrollTop = this.props.scrTop;
      }

      /*
       * 別ウィンドウのスクロール（左右）連動
       * @since hara 2021-02-09
       */
      if (prevProps.scrLeft !== this.props.scrLeft) {
        const XList = document.getElementById("sepSw_XList");
        const main = document.getElementById("sepSw_main");
        XList.scrollLeft = this.props.scrLeft;
        main.scrollLeft = this.props.scrLeft;
      }
    }
  }

  /*
   * 断面ライン選択変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeCsLine(e) {
    const value = parseInt(e.target.value);
    window.hglCsLine(value + 1);
    this.props.dispatch(changeCsLineAction(value));

    if (this.$cell !== null) this.$cell.classList.remove("cellClick"); //赤枠削除
    this.props.dispatch(resetCellAction());

    this.createDiag(value, true);
  }

  /*
   * 標高・深度ラジオ変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeElvDepRdo(e) {
    this.elvDepRdo = e.target.value;
    this.props.dispatch(changeElvDepRdoAction(this.elvDepRdo));
    this.createDiag(this.props.csLine, true);
  }

  /*
   * 補助目盛線 (Y軸）を表示チェック変更
   * @param {Event} e イベント情報
   * @since hara 2020-10-23
   */
  changeYLineChk(e) {
    this.YLineChk = e.target.checked;
    this.props.dispatch(changeYLineChkAction(this.YLineChk));
    this.createDiag(this.props.csLine);
  }

  /*
   * 地下水位を表示チェック変更
   * @param {Event} e イベント情報
   * @since hara 2022-03-17
   */
  changeWlChk(e) {
    this.wlChk = e.target.checked;
    this.props.dispatch(changeWlChkAction(this.wlChk));
    this.createDiag(this.props.csLine);
  }

  /*
   * ボーリングを表示チェック変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeBoringChk(e) {
    this.boringChk = e.target.checked;
    this.props.dispatch(changeBoringChkAction(this.boringChk));
    this.createDiag(this.props.csLine, false, true);
  }

  /*
   * 予測確率コンターを表示チェック変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeProbChk(e) {
    this.probChk = e.target.checked;
    this.props.dispatch(changeProbChkAction(this.probChk));
    this.createDiag(this.props.csLine);
  }

  /*
   * 確率コンターサブウィンドウを開く
   * @since hara 2020-10-26
   */
  openProbSw() {
    this.props.dispatch(openProbAction(true));
  }

  /*
   * 標尺(X軸)入力変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeXScale(e) {
    this.props.dispatch(changeXScaleAction(e.target.value));
  }

  /*
   * 標尺(Y軸)入力変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeYScale(e) {
    this.props.dispatch(changeYScaleAction(e.target.value));
  }

  /*
   * 補助目盛線 (Y軸)入力変更
   * @param {Event} e イベント情報
   * @since hara 2020-10-23
   */
  changeYLine(e) {
    this.props.dispatch(changeYLineAction(e.target.value));
  }

  /*
   * ボーリング幅入力変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeBWidth(e) {
    this.bWidth = e.target.value;
    this.props.dispatch(changeBWidthAction(this.bWidth));
  }

  /*
   * 推定地質セルクリック
   * @param {Number} selIndex 推定断面インデックス
   * @param {Number} dataIndex 推定ボーリングインデックス
   * @param {Number} geoIndex 推定地質インデックス
   * @since hara 2020-09-09
   */
  clickCell(e, selIndex, dataIndex, geoIndex) {
    const data = this.props.resultDs[selIndex].data[dataIndex];
    const geo = data.geo[geoIndex];
    const thk = geo[0];
    const geoID = geo[1];
    const prob = geo[2];
    const elev = Math.round((data.GL - geoIndex * thk) * 100) / 100; //小数第2位で四捨五入
    const dep = geoIndex * thk;

    this.getDecPath(selIndex, dataIndex, geoIndex);
    this.props.dispatch(
      clickCellAction(
        selIndex,
        dataIndex,
        geoIndex,
        prob.map(e => e.toFixed(2)),
        data.GL,
        data.WL,
        elev,
        dep,
        geoID
      )
    );

    //赤枠をつける
    if (this.$cell !== null) this.$cell.classList.remove("cellClick");
    this.$cell = e.target;
    this.$cell.classList.add("cellClick");
  }

  /*
   * 図作成
   * @param {Number} csLineIndex 断面ラインインデックス
   * @param {Boolean} isInit true=初期値による表示/false=入力値による表示
   * @param {Boolean} isBoring true=ボーリングを表示/false=入力値による表示
   * @since hara 2020-09-09
   */
  createDiag(csLineIndex, isInit, isBoring) {
    //        this.maxY = this.props.modelDep;
    //学習実行時、モデル深度を入力（考慮）できるようになったら上のコメント外し、
    //下の******で囲まれた仮プログラムを削除する
    //*******
    this.maxY = 0;
    this.props.resultDs[0].data[0].geo.forEach(el => {
      this.maxY += el[0];
    });
    //*******
    this.XList = [];
    this.YList = [];
    this.YLineList = [];
    this.wlData = [];
    this.wlLineList = [];
    this.bList = [];
    this.bList2 = [];
    this.probList = [];
    this.YLineW = 0;

    //目盛設定
    this.setScale(isInit, isBoring, csLineIndex);

    //レイヤー作成
    this.createLayer(0, csLineIndex);
    if (this.boringChk) this.createLayer(1, csLineIndex);

    //目盛作成
    this.createScale("x", this.XScale, this.maxX);
    this.createScale("y", this.YScale, this.maxY);

    //補助目盛線レイヤー作成
    if (this.YLineChk) this.createLineLayer();

    //地下水位レイヤー作成
    if (this.wlChk) this.createWlLayer();

    this.props.dispatch(changeXScaleAction(this.XScale));
    this.props.dispatch(changeYScaleAction(this.YScale));
    this.props.dispatch(changeYLineAction(this.YLine));
    this.props.dispatch(changeBWidthAction(this.bWidth));
    this.props.dispatch(changeXListAction(this.XList));
    this.props.dispatch(changeYListAction(this.YList));
    this.props.dispatch(changeYLineListAction(this.YLineList));
    this.props.dispatch(changeWlLineListAction(this.wlLineList));
    this.props.dispatch(changeBListAction(this.bList));
    this.props.dispatch(changeBList2Action(this.bList2));
    this.props.dispatch(changeProbListAction(this.probList));
  }

  /*
   * 目盛設定
   * @param {Boolean} isInit 初期値による表示/入力値による表示
   * @param {Boolean} isBoring true=ボーリングを表示/false=ボーリングを非表示
   * @param {Number} selIndex 断面ラインインデックス
   * @since hara 2020-09-09
   */
  setScale(isInit, isBoring, selIndex) {
    /*
     * 軸最大値を算出
     */
    const calcMaxScale = () => {
      this.maxX = 0;
      this.elevMaxY = null;
      this.elevMinY = null;

      this.props.resultDs[selIndex].data.forEach((el, index) => {
        /*
         * X軸最大値を算出
         */
        this.maxX += el.dist;

        /*
         * 標高表示の場合、Y軸最大値を更新・Y軸最小値を更新
         */
        if (this.elvDepRdo === "elev") {
          //最大標高を更新
          if (this.elevMaxY === null || this.elevMaxY < el.GL) this.elevMaxY = el.GL;

          //最小標高を更新(目盛用・ボーリングは未考慮)
          if (this.elevMinY === null || el.GL - this.maxY < this.elevMinY) this.elevMinY = el.GL - this.maxY;
        }
      });
    };

    if (isInit) {
      //初期値による表示の場合
      const root = 16; //rootのフォントサイズ(商用版ではディスプレイサイズによって可変とする)
      const dspW = (48.5 - 1) * root; //-1はスクロールバー分
      const dspH = (26.5 - 1) * root;
      const XScaleNum = Math.floor(dspW / this.scaleWidth); //X軸目盛数
      const YScaleNum = Math.floor(dspH / this.scaleWidth); //Y軸目盛数

      calcMaxScale();

      //X軸標尺
      this.XScale = Math.ceil(this.maxX / XScaleNum);
      //Y軸標尺
      if (this.elvDepRdo === "elev")
        //標高表示の場合
        this.maxY = Math.ceil(this.elevMaxY) - Math.floor(this.elevMinY);
      this.YScale = Math.ceil(this.maxY / YScaleNum);
      //ボーリング表示幅
      this.bWidth = this.XScale;

      //補助目盛線(Y軸)
      this.YLine = redYLine;
      console.log(redYLine);
    } else {
      //入力値による表示の場合
      //ボーリング表示切替の場合
      if (isBoring) calcMaxScale();

      //X軸標尺(最小単位0.5)
      if (0.5 <= this.props.XScale) this.XScale = this.props.XScale;
      //Y軸標尺(最小単位0.5)
      if (0.5 <= this.props.YScale) this.YScale = this.props.YScale;
      //Y軸補助目盛線(最小単位0.5)
      //if (0.5 <= this.props.YLine) this.YLine = this.props.YLine;
      if (0.5 <= this.props.YLine) this.YLine = this.props.YLine;
      //ボーリング表示幅
      if (parseInt(this.props.bWidth) < parseInt(this.XScale)) {
        //X軸の1目盛よりボーリング幅が小さい場合X軸の1目盛の幅を最小値とする
        this.bWidth = this.XScale;
      } else if (this.maxX < this.props.bWidth) {
        //X軸目盛の全体幅よりボーリング幅が大きい場合X軸目盛の全体幅を最大値とする
        this.bWidth = this.maxX;
      }
    }
  }

  /*
   * レイヤー作成
   * @param {Number} layerFlg 0=予測ストリップレイヤー作成/1=登録ボーリングレイヤー作成
   * @param {Number} selIndex 断面ラインインデックス
   * @since hara 2020-09-09
   */
  createLayer(layerFlg, selIndex) {
    let count = -1; //断面ライン座標の配列カウンター
    let spaceT = 0; //標高表示時のトップ位置
    let spaceL = null; //ボーリング表示時のレフト位置
    let sum = 0; //ボーリング表示時のレフト位置カウンター
    let wl = null; //地下水位位置

    this.props.resultDs[selIndex].data.forEach((el, index) => {
      if (this.elvDepRdo === "elev") {
        //標高表示の場合
        spaceT = ((Math.ceil(this.elevMaxY) - el.GL) * this.scaleWidth) / this.YScale;
      }

      if (layerFlg === 0) {
        //予測ストリップレイヤー作成の場合
        let isBorderL = false;
        let isBorderR = false;
        if (el.flg === 1 || el.flg === 3) isBorderL = true;
        if (el.flg === 2 || el.flg === 3) isBorderR = true;

        const width = (el.dist * this.scaleWidth) / this.XScale;
        this.YLineW += width;

        if (this.wlChk) {
          //地下水位表示の場合
          //地下水位位置
          wl = spaceT + ((el.GL - el.WL) * this.scaleWidth) / this.YScale;
          //2 = borderの太さ（border-bottom4px）の半分2px
          wl = wl + 2;
          this.wlData.push({ wl: wl, width: width });
        }

        const createUl = isProb => {
          return (
            <ul
              id={index}
              className="Boring"
              style={{
                borderLeft: isBorderL && "3px #ff2222 dashed",
                borderRight: isBorderR && "3px #ff2222 dashed",
                marginTop: spaceT,
                width: width + "px",
              }}
              onMouseEnter={this.hglCsLineSec}
              onMouseLeave={() => this.hglCsLineSec(null)}
              key={index}>
              {this.createBoring(el, null, false, isProb, "dep", selIndex, index)}
            </ul>
          );
        };
        this.bList.push(createUl(this.probChk));
        this.probList.push(createUl(true));
      } else {
        //登録ボーリングレイヤー作成の場合
        if (el.flg !== 0) {
          /*
           * 登録ボーリングレイヤー作成
           * @param {Number} count 断面ライン座標インデックス
           * @param {Number} spaceL ボーリングのレフト位置
           */
          const createRegLay = (count, spaceL) => {
            const boringID = this.props.csLineDs[selIndex].coords[count][0];
            if (boringID !== null && boringID !== undefined) {
              //ボーリングポイントの場合
              //同地点に複数ボーリングが存在するか確認
              let boringIDD = boringID.split("_");
              const coord = this.props.boringDs[boringIDD[0]].data[boringIDD[1]];
              const sameCoordID = window.getSameCoordID(coord.lon, coord.lat);

              if (1 < sameCoordID.length) {
                //同地点に複数ボーリングが存在する場合
                sameCoordID.forEach(el => {
                  const elID = el.split("_");

                  if (this.props.boringDs[elID[0]].data[elID[1]].sel !== undefined) {
                    //selプロパティーがある場合
                    boringIDD = elID;
                  }
                });
              }

              const ds = this.props.boringDs[boringIDD[0]];
              const data = ds.data[boringIDD[1]];
              this.bList2.push(
                <div className="CSDsp__main__layer">
                  <div className="boringBlank" style={{ width: spaceL + "px" }}></div>
                  <ul
                    className="Boring"
                    style={{
                      outline: "3px ridge white",
                      outlineOffset: "-3px",
                      marginTop: spaceT,
                      pointerEvents: this.editerSw ? "none" : "auto",
                      width: (this.bWidth * this.scaleWidth) / this.XScale + "px",
                    }}
                    onMouseEnter={() => this.hglBoring(boringIDD[0], boringIDD[1])}
                    onMouseLeave={() => this.hglBoring(null)}
                    key={index}>
                    {this.createBoring(data, el.GL, true, this.probChk, ds.depThkRdo, selIndex, index)}
                  </ul>
                </div>
              );
            }
          };

          count++;
          if (sum === 0) {
            //左端の場合
            spaceL = 0;
            createRegLay(count, spaceL);
          } else if (el.flg === 2) {
            //右端・分割数2以上の場合
            spaceL = ((sum + el.dist - this.bWidth) * this.scaleWidth) / this.XScale;
            createRegLay(count, spaceL);
          } else {
            spaceL = ((sum - this.bWidth / 2) * this.scaleWidth) / this.XScale;
            createRegLay(count, spaceL);
            if (el.flg === 3) {
              //右端・分割数1の場合
              spaceL = ((sum + el.dist - this.bWidth) * this.scaleWidth) / this.XScale;
              createRegLay(count + 1, spaceL);
            }
          }
          sum += el.dist;
        } else {
          sum += el.dist;
        }
      }
    });
  }

  /*
   * 補助目盛線レイヤー作成
   * @since hara 2020-10-23
   */
  createLineLayer() {
    let count = 0;
    const isElev = this.elvDepRdo === "elev";
    //整数値にする
    let minVal = isElev ? Math.ceil(this.elevMaxY) - this.maxY : 0;
    let maxVal = isElev ? Math.ceil(this.elevMaxY) : this.maxY;

    for (let i = minVal; i <= maxVal; i += parseFloat(this.YLine)) {
      if (i % this.YLine === 0) {
        let height;
        if (isElev) {
          //標高表示の場合
          height = Math.ceil(this.elevMaxY) - i;
        } else {
          //深度表示の場合
          height = this.YLine * count;
          count++;
        }

        this.YLineList.push(
          <div
            className="CSDsp__main__lineLayer"
            style={{
              height: (height * this.scaleWidth) / this.YScale + "px",
              width: this.YLineW + "px",
            }}
            key={i}></div>
        );
      }
    }
  }

  /*
   * 地下水標高レイヤー作成
   * @since hara 2022-03-23
   */
  createWlLayer() {
    let left = 0;
    this.wlData.forEach((el, index) => {
      this.wlLineList.push(
        <div
          className="CSDsp__main__wlLayer"
          style={{
            left: left,
            height: el.wl + "px",
            width: el.width + "px",
          }}
          key={index}></div>
      );
      left = left + el.width;
    });
  }

  /*
   * ボーリング作成
   * @param {Array} el 推定ボーリングデータ
   * @param {Number} GL 地点標高
   * @param {Boolean} isBoring true=登録ボーリングレイヤ作成 / false=予測ストリップレイヤ作成
   * @param {Boolean} isProb true=予測確率コンター表示 / false=予測確率コンター非表示
   * @param {String} depThkRdo 'dep'=登録ボーリング地質のZ属性が深度 / 'thk'=層厚
   * @param {Number} selIndex 断面ラインインデックス
   * @param {Number} dataIndex 推定ボーリングインデックス
   * @since hara 2020-09-09
   */
  createBoring(el, GL, isBoring, isProb, depThkRdo, selIndex, dataIndex) {
    let arr = [];
    let depth = 0;
    let thisMaxY = 0;

    const allGeos = this.props.geoDs.flatMap(ds => ds.geo);
    el.geo.forEach((el2, index2) => {
      const sel = allGeos.find(item => item.ID === el2[1]);
      if (sel == undefined) {
        console.log("");
      }
      if (index2 == 0) {
        console.log("");
      }
      let height;
      if (isBoring) {
        //ボーリング有りの場合
        if (depThkRdo === "dep") {
          //深度の場合（商用版では、層厚か深度かフラグ判定）
          if (index2 === 0) {
            height = el2[0];
          } else {
            height = el2[0] - depth;
          }
        } else {
          //層厚の場合
          height = el2[0];
        }
        thisMaxY += height;
      } else {
        //ボーリング無しの場合
        height = el2[0];
        thisMaxY += height;
      }

      let li;
      if (!isBoring && isProb) {
        //確率コンターの場合
        li = (
          <li
            id={"csDspProbCell_" + selIndex + "-" + dataIndex + "-" + index2}
            className="cellHover"
            onMouseEnter={e => this.hglCell(e, selIndex + "-" + dataIndex + "-" + index2)}
            onMouseLeave={() => this.hglCell(null)}
            style={{
              backgroundColor: getContColor(el2[2]),
              height: (height * this.scaleWidth) / this.YScale + "px",
            }}
            key={index2}></li>
        );
      } else if (!isBoring) {
        //予測ストリップの場合
        li = (
          <li
            id={"csDspMainCell_" + selIndex + "-" + dataIndex + "-" + index2}
            className="cellHover"
            onClick={e => this.clickCell(e, selIndex, dataIndex, index2)}
            onMouseEnter={e => this.hglCell(e, selIndex + "-" + dataIndex + "-" + index2)}
            onMouseLeave={() => this.hglCell(null)}
            style={{
              backgroundColor: sel.color,
              height: (height * this.scaleWidth) / this.YScale + "px",
            }}
            key={index2}></li>
        );
      } else {
        //登録ボーリングの場合
        li = (
          <li
            style={{
              backgroundColor: sel.color,
              height: (height * this.scaleWidth) / this.YScale + "px",
            }}
            key={index2}></li>
        );
      }
      arr.push(li);

      depth = el2[0];
    });

    if (this.maxY < thisMaxY) {
      this.maxY = thisMaxY;
    }

    if (this.elvDepRdo === "elev" && isBoring) {
      //標高表示かつボーリング表示の場合
      if (GL - thisMaxY < this.elevMinY) {
        this.elevMinY = GL - thisMaxY;
        this.maxY = Math.ceil(this.elevMaxY) - Math.floor(this.elevMinY);
      }
    } else if (this.elvDepRdo === "elev") {
      //標高表示の場合
      this.maxY = Math.ceil(this.elevMaxY) - Math.floor(this.elevMinY);
    }

    return arr;
  }

  /*
   * 目盛作成
   * @param {Array} cat 目盛軸種別
   * @param {Number} scale 1目盛値
   * @param {Boolean} max 目盛最大値
   * @since hara 2020-09-09
   */
  createScale(cat, scale, max) {
    let arr = cat === "x" ? this.XList : this.YList;
    const num = Math.ceil(max / scale);
    let value = null;
    for (let i = 1; i <= num; i++) {
      if (this.elvDepRdo === "elev" && cat === "y") {
        //標高表示のY軸標尺
        if (i === 1) {
          value = Math.ceil(this.elevMaxY) - scale;
        } else {
          value = value - scale;
        }
      } else {
        value = scale * i;
      }
      arr.push(
        <div className={cat === "x" ? "scaleX" : "scaleY"} key={i}>
          {value.toFixed(window.getDecDig(scale))}
        </div>
      );
    }
  }

  /*
   * 目盛スクロール
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  doScroll(e) {
    const top = e.target.scrollTop;
    const left = e.target.scrollLeft;

    this.scaleYRef.scrollTop = top;
    this.scaleXRef.scrollLeft = left;

    this.props.dispatch(scrTopAction(top));
    this.props.dispatch(scrLeftAction(left));
  }

  /*
   * ボーリングハイライト
   * @param {String} ID1 ボーリングID1
   * @param {String} ID2 ボーリングID2
   * @since hara 2020-09-09
   */
  hglBoring(ID1, ID2) {
    if (ID1 !== null) {
      window.hglBoring(ID1, ID2);
    } else {
      window.dehglBoring();
    }
  }

  /*
   * セルハイライト
   * @param {Event} e イベント情報
   * @param {String} num IDの番号
   * @since hara 2021-02-25
   */
  hglCell(e, num) {
    //別ウィンドウが開いている場合
    if (this.props.probSw) {
      if (e === null) {
        //leave時、ハイライト解除
        if (this.$hoverCell !== null) this.$hoverCell.classList.remove("cellBorder");
      } else {
        //mouseover時、ハイライト
        const IDHead = e.target.id.match(/csDspMainCell/) ? "csDspProbCell_" : "csDspMainCell_";
        this.$hoverCell = document.getElementById(IDHead + num);
        this.$hoverCell.classList.add("cellBorder");
      }
    }
  }

  /*
   * 断面ライン区間ハイライト
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  hglCsLineSec(e) {
    if (e !== null) {
      //ハイライト
      const id = e.currentTarget.id;
      const boringData = this.props.resultDs[this.props.csLine].data;
      const csLineCoords = this.props.csLineDs[this.props.csLine].coords;

      const data1 = boringData[id];
      const lon1 = data1.lon;
      const lat1 = data1.lat;

      let data2;
      let lon2;
      let lat2;
      if (parseInt(id) === boringData.length - 1) {
        //最後の推定ボーリングの場合
        data2 = csLineCoords[csLineCoords.length - 1];
        lon2 = data2[1];
        lat2 = data2[2];
      } else {
        data2 = boringData[parseInt(id) + 1];
        lon2 = data2.lon;
        lat2 = data2.lat;
      }

      window.hglCsLineSec([
        [lon1, lat1],
        [lon2, lat2],
      ]);
    } else {
      //デハイライト
      window.dehglCsLineSec();
    }
  }

  /*
   * 地質推定時の決定木の結果を取得
   * @param {Number} selIndex 推定断面インデックス
   * @param {Number} dataIndex 推定ボーリングインデックス
   * @param {Number} geoIndex 推定地質インデックス
   * @since kawai 2020-09-19
   */
  getDecPath(selIndex, dataIndex, geoIndex) {
    const lon = this.props.resultDs[selIndex].data[dataIndex].lon;
    const lat = this.props.resultDs[selIndex].data[dataIndex].lat;
    const depth = this.props.resultDs[selIndex].data[dataIndex].geo[geoIndex][0] * geoIndex;
    console.log(`lon:${lon}, lat:${lat}, depth:${depth}, selIndex:${selIndex}`);
    /*検証用
                const waiting = (stat) => {
                    document.body.style.cursor = stat ? 'wait' : 'auto';
                };

                waiting(true);
                let data = {
                    cell: { Longitude: lon, Latitude: lat, depth: depth, selIndex: selIndex },
                    type: 'cell'
                };
                const origin = window.location.origin;
                const search = window.location.search
                //TODO:userIDは暫定で0としている。ユーザログイン機能が実装されたら可変とする
                fetch(`${origin}/api/0/predict/${search}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                })
                    .then(response => response.json())
                    .then(results => {
                        //console.log(results);
                        waiting(false);
                    })
                    .catch(err => {
                        console.log(err);
                        waiting(false);
                    });
        */
  }

  render() {
    return (
      <div>
        {this.props.resultDs.length === 0 ? (
          <p>予測結果が存在しません。</p>
        ) : (
          <div>
            <div className="l-row">
              <label>断面ライン：</label>
              <select className="selectM" value={this.props.csLine} onChange={this.changeCsLine}>
                {this.props.resultDs.map((el, index) => (
                  <option value={index} key={index}>
                    {this.props.csLineDs[index].ID + " : " + this.props.csLineDs[index].name}
                  </option>
                ))}
              </select>
              <p className="l-blank">
                分割数 (目安)：
                {divNumOpt[this.props.csLineDs[this.props.csLine].divNum]}
              </p>
              <p className="l-blank">総延長 [m]：{this.maxX.toFixed(2)}</p>
              {this.elevMaxY !== null && (
                <div className="l-row">
                  <p className="l-blank">最大標高 [m]：{this.elevMaxY.toFixed(1)}</p>
                  <p className="l-blank">最小標高 [m]：{this.elevMinY.toFixed(1)}</p>
                </div>
              )}
            </div>

            <div className="l-row l-mtS">
              <p>
                <input id="csDspMain_elevRdo" className="radio" value="elev" name="csDspMain_elvDepRdo" type="radio" checked={this.props.elvDepRdo === "elev"} onChange={this.changeElvDepRdo} />
                <label htmlFor="csDspMain_elevRdo">標高</label>
                <input id="csDspMain_depRdo" className="radio" value="dep" name="csDspMain_elvDepRdo" type="radio" checked={this.props.elvDepRdo === "dep"} onChange={this.changeElvDepRdo} />
                <label htmlFor="csDspMain_depRdo" className="l-mlM">
                  深度
                </label>
              </p>
              <p className="l-blank">
                <input id="csDspMain_YLineChk" className="check" type="checkbox" onChange={this.changeYLineChk} defaultChecked={this.props.YLineChk} />
                <label htmlFor="csDspMain_YLineChk">補助目盛線 (Y軸）を表示</label>
              </p>
              <p className="l-blank">
                <input id="csDspMain_boringChk" className="check" type="checkbox" onChange={this.changeBoringChk} defaultChecked={this.props.boringChk} />
                <label htmlFor="csDspMain_boringChk">ボーリングを表示</label>
              </p>
              <p className="l-blank">
                <input id="csDspMain_wlChk" className="check" type="checkbox" onChange={this.changeWlChk} defaultChecked={this.props.wlChk} />
                <label htmlFor="csDspMain_wlChk">地下水標高を表示</label>
              </p>
              <p className="l-blank">
                <input id="csDspMain_probChk" className="check" type="checkbox" onChange={this.changeProbChk} defaultChecked={this.props.probChk} />
                <label htmlFor="csDspMain_probChk" className={this.props.probSw ? "disabled" : ""}>
                  予測確率コンターを表示
                </label>
              </p>
              <button className={this.props.probChk ? "disabled sBtn l-mlM" : "sBtn l-mlM"} onClick={this.openProbSw}>
                別ウィンドウ
              </button>
            </div>

            <div className="l-row l-mtS">
              <label>標尺 (X軸)：</label>
              <input className="textS" type="text" value={this.props.XScale} onChange={this.changeXScale} />
              <label className="l-blank">標尺 (Y軸)：</label>
              <input className="textS" type="text" value={this.props.YScale} onChange={this.changeYScale} />
              <label className="l-blank">補助目盛線 (Y軸)：</label>
              <input className={this.props.YLineChk ? "textS" : "textS disabled"} type="text" value={this.props.YLine} onChange={this.changeYLine} />
              <label className="l-blank">ボーリング表示幅：</label>
              <input className={this.props.boringChk ? "textS" : "textS disabled"} type="text" value={this.props.bWidth} onChange={this.changeBWidth} />
              <button className="sBtn l-mlM" onClick={() => this.createDiag(this.props.csLine)}>
                適用
              </button>
              <button className="sBtn l-mlS" onClick={() => this.createDiag(this.props.csLine, true)}>
                初期値
              </button>
            </div>

            <div className="l-flex l-mtS">
              <div className="CSDsp">
                <div className="l-flex">
                  <div className="CSDsp__corner"></div>
                  <div className="CSDsp__x" ref={ref => (this.scaleXRef = ref)}>
                    {this.props.XList}
                  </div>
                </div>
                <div className="CSDsp__wrap">
                  <div className="CSDsp__y" ref={ref => (this.scaleYRef = ref)}>
                    {this.props.YList}
                  </div>
                  <div className="CSDsp__main" onScroll={e => this.doScroll(e)}>
                    <div className="CSDsp__main__layer">{this.props.bList}</div>
                    {this.props.bList2}
                    {this.props.YLineList}
                    <div>{this.props.wlLineList}</div>
                  </div>
                </div>
              </div>
              <div className="l-mlM">
                <Lgd data={this.props.probChk ? "" : this.props.geoDs[0].geo} cat={this.props.probChk ? "prob" : "geo"} isRsltCs={true} cellInfo={this.props.cellInfo} />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Main);
